import TabsController from "./tabs_controller"

// Connects to data-controller="club-settings-tabs"
export default class extends TabsController { }
